var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00415 4.74866L11.6219 7.23549L11.6343 7.10523C11.6343 5.79864 10.5166 4.73682 9.14127 4.73682L9.00415 4.74866Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14116 3.15775C11.4348 3.15775 13.2963 4.92618 13.2963 7.10512C13.2963 7.61433 13.1883 8.09985 13.0013 8.54589L15.432 10.8551C16.6869 9.86036 17.6758 8.57353 18.2866 7.10512C16.8448 3.63935 13.3005 1.18408 9.1412 1.18408C7.97776 1.18408 6.86421 1.38144 5.82959 1.7367L7.6246 3.438C8.09407 3.26433 8.60515 3.15775 9.14116 3.15775Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.83101 1.00658L2.72574 2.80657L3.10387 3.16579C1.73268 4.18421 0.648198 5.53817 0 7.10524C1.43768 10.571 4.98614 13.0263 9.14126 13.0263C10.4294 13.0263 11.6593 12.7894 12.7853 12.3592L13.1385 12.6947L15.561 14.9999L16.6205 13.9973L1.89056 0L0.83101 1.00658ZM5.42659 5.36842L6.71052 6.58815C6.67312 6.7579 6.64819 6.92761 6.64819 7.10524C6.64819 8.41183 7.76591 9.47365 9.14126 9.47365C9.32824 9.47365 9.50692 9.44997 9.68144 9.41444L10.9654 10.6342C10.4127 10.8947 9.7978 11.0526 9.14126 11.0526C6.84764 11.0526 4.98614 9.28418 4.98614 7.10524C4.98614 6.48157 5.15235 5.89735 5.42659 5.36842Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.fa0abd51.svg";
export { ForwardRef as ReactComponent };